import PropTypes from 'prop-types'
import { SearchIcon, SortIcon } from '../../../../assets/svg'

const Filters = ({ query, onQueryChange }) => (
  <div className="mb-[1.25rem] flex items-center gap-[0.625rem]">
    <label className="flex w-full sm:flex-1 sm:max-w-[24.375rem] items-center gap-[0.625rem] rounded-[10px] border border-solid border-[#d9d9d9] bg-white px-[1rem] py-[0.75rem] sm:py-[0.875rem]">
      <SearchIcon />
      <input
        type="text"
        value={query}
        onChange={(e) => onQueryChange(e.target.value)}
        placeholder="Поиск по названию, месту, комиссии..."
        className="flex-1 min-w-0 bg-transparent text-[0.875rem] sm:text-[0.938rem] text-[#111827] placeholder:text-[#9ca3af] outline-none"
      />
    </label>

    <button
      type="button"
      className="ml-auto flex h-[3rem] w-[3rem] items-center justify-center rounded-[10px] border border-solid border-[#d9d9d9] bg-white shrink-0"
    >
      <SortIcon />
    </button>
  </div>
)

Filters.propTypes = {
  query: PropTypes.string.isRequired,
  onQueryChange: PropTypes.func.isRequired,
}

export default Filters
